import axios from 'axios';
import type { identifier } from '@core/models/base';
import { axiosToServiceResult } from '@shared/axios';
import type { GreenScreenBackgroundDisplayModel } from '@shared/models/packages/greenScreenBackgrounds';

export const fetchGreenScreens = async (jobId: identifier) =>
  axiosToServiceResult(axios.get<GreenScreenBackgroundDisplayModel[]>(`/api/customer/jobs/${jobId}/greenscreens`));
